import { CaseDeserialized } from "src/cases/queries/casesTypes";
import { FEATURE_FLAGS, isFeatureFlagEnabled } from "src/router/featureFlags";

export const isCaseCopilotEnabled = (caseData?: CaseDeserialized): boolean => {
  return (
    isFeatureFlagEnabled(FEATURE_FLAGS.caseCopilot) &&
    caseData?.data.template_version?.copilot_settings?.copilot_enabled === true
  );
};
